<template>
  <div class="example-avatar">
    {{ comp_Parent_Property }}{{getConfirmBoxResponse}}
    <!-- {{com_gett_deletededfile}}
    {{com_default_logo_url}}
    {{default_logo_url}} -->
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Drop files to upload</h3>
    </div>
    <div class="row avatar-upload " v-show="!edit">
      <div class="col-md-5">
        <div class="text-center">
          <span style="display:none;">{{ com_gett_deletededfile }}</span>
          <span style="display:none;"> {{ com_gett_uploadedfile }}</span>
          <span style="display:none;"> {{ com_default_logo_url }}</span>
          <label for="avatar">
            <div class="row">
              <div class="col-md-12 uploaded-image-box">
                <!-- <img
                  :src="staffpicfile.length ? staffpicfile[0].url : default_logo_url"
                  class="rounded-circle"
                /> -->
                <img
                  :src="uploadesImageUrl ? uploadesImageUrl : default_logo_url"
                  class="rounded-circle"
                />
                 <!-- <img
                  src="https://documents-gen-ehr-dev.s3.amazonaws.com/4ba133a2-1e8f-4fad-9eea-cbc453638e61/documents/reports-images/4ba133a2-1e8f-4fad-9eea-cbc453638e61_1f063264-c107-4b2f-b506-ee10ff4c8d42_Desert.jpg?AWSAccessKeyId=ASIA5BLF7Z4HEP43OKX5&Expires=1582790419&x-amz-security-token=IQoJb3JpZ2luX2VjEPD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJGMEQCIHwMHwbSeyhDgvkM%2BEC9mt9I0MkBf3zKthpqw5gE3IAqAiBcs0sWB7WKH9J75IORsnGPLcQK39S0n%2BedFj9Jy83ACCr6AQi5%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAEaDDg5NjI1MTQ0OTEwMiIMJshnuD2PCiG3G2lbKs4B1ti%2FNhhKYwnICPRcxinH54xvW8zeJ9qTqvlI%2FW1EN5Zns8U2apDF71DyAJq4GZ0N71r%2FfIM4hVwYmi1g9b3B2FqcwE5ssNJdy4AT3OlhDigOLwN92p3PrnAaZpfw9EXNqNilELbGykDVPqoF7stju%2BgbilLp5OdOmUH4XjrPke7al7huh8JXkfN%2B8%2BKSwuC%2FnP%2FtMWq7O5UDA35818f5ETo9F0%2BojtFMdwQ9A4wbQHlUpxM7JgXgw97TvKoAYfnt7Okz3PzWX3qOXW9Zbvcw29zd8gU64QF5HjBFhjqorARKEMCzpaPr72lN6F%2Fn3%2Bf0QE6jgtaw9ao13gWYZQB7sbCAEwLOKlIYxwCORDP5BiMEgWKp13kzM9fgzxUxRta9pGz2ZUzIdihZEnPrzAs1iuMA5pZUoAPLHqrK50vRsU2e%2BENREhO6JrNbGTkDmBrpkZ25bt9bdvmAu%2FBptlBBA6shhcKFiwT4CtSBORFB4tgsk0%2FuEIjrKVIS4PnppcFO%2FHyjoKybm4Z8p%2BBmjeO4Ehe0gmvnzA7ue6GxJtMjaJvKR%2F5i8ONlsRks7waZn4THEcpI5nDWp7M%3D&Signature=3CI9%2BhjrqeDqWFsNP4dme74QXEU%3D"
                  class="rounded-circle"
                /> -->
                <div
                v-if="imagecount>0"
                  class="multi-image"
                  @click="listImages"
                >
                  +{{ imagecount }}
                </div>
                <div class="multi-images-list" ref="dropdownImageList" v-bind:class="showimglist?'block':'none'">
                  <div class="col-md-12">
                    <div class="row" v-if="UploadedImage" v-for="(item, index) in UploadedImage">
                      <div class="col-md-8 p-0 text-left image-name">
                        <a
                          @click="viewFile(item.file_key, 'file')"
                          :href="getdownloadfileUrl"
                          data-toggle="tooltip"
                          :data-original-title="item.Image_Name"
                          >{{ item.Image_Name }}</a
                        >
                        <span>{{ item.Uploaded_date }}</span>
                      </div>
                      <div class="col-md-2">
                        <a
                          @click="viewFile(item.file_key, 'file')"
                          :href="getdownloadfileUrl"
                          ><i
                            class="material-icons view-image"
                            data-toggle="tooltip"
                            data-original-title="View"
                            >visibility</i
                          >
                        </a>
                      </div>
                      <div class="col-md-2">
                        <a @click="deleteImage(item.unique_id, item.encounter_id)" href="#"
                          ><i
                            class="material-icons delete-image"
                            data-toggle="tooltip"
                            data-original-title="Delete"
                            >delete</i
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-8 p-0 text-left image-name">
                        <a
                          href="javascript:void(0);"
                          data-toggle="tooltip"
                          data-original-title="loremipsumImage123456789.jpg"
                          >loremipsumImage123456789.jpg</a
                        >
                        <span>02.02.2020</span>
                      </div>
                      <div class="col-md-2">
                        <a href="#"
                          ><i
                            class="material-icons view-image"
                            data-toggle="tooltip"
                            data-original-title="View"
                            >visibility</i
                          >
                        </a>
                      </div>
                      <div class="col-md-2">
                        <a href="#"
                          ><i
                            class="material-icons delete-image"
                            data-toggle="tooltip"
                            data-original-title="Delete"
                            >delete</i
                          ></a
                        >
                      </div>
                    </div>
                  </div> -->
                  <!-- <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-8 p-0 text-left image-name">
                        <a
                          href="javascript:void(0);"
                          data-toggle="tooltip"
                          data-original-title="loremipsumImage123456789.jpg"
                          >loremipsumImage123456789.jpg</a
                        >
                        <span>02.02.2020</span>
                      </div>
                      <div class="col-md-2">
                        <a href="#"
                          ><i
                            class="material-icons view-image"
                            data-toggle="tooltip"
                            data-original-title="View"
                            >visibility</i
                          >
                        </a>
                      </div>
                      <div class="col-md-2">
                        <a href="#"
                          ><i
                            class="material-icons delete-image"
                            data-toggle="tooltip"
                            data-original-title="Delete"
                            >delete</i
                          ></a
                        >
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>

      <div class="col-md-7 flex">
        <div class="text-center">
          <button
            class="btn  secondary-btn btn-input"
            style="display:none;"
            v-if="show_remove_logo_button"
            v-on:click="RemoveStaffprofilepicture()"
          >
            Remove
          </button>
          <file-upload
            extensions="gif,jpg,jpeg,png,webp"
            accept="image/png,image/gif,image/jpeg,image/webp"
            name="staffpicupload"
            class="primary-btn ripple btn-center"
            :drop="!edit"
            v-model="staffpicfile"
            input-id="file2"
            @input-filter="inputFilter"
            @input-file="inputFile"
            ref="upload"
          >
            Upload
          </file-upload>
        </div>
      </div>
    </div>

    <div class="avatar-edit" v-show="staffpicfile.length && edit">
      <div class="avatar-edit-image" v-if="staffpicfile.length">
        <img ref="editImage" :src="staffpicfile[0].url" />
      </div>
      <div class="text-center p-2">
        <!-- <button
          type="button"
          class="btn secondary-btn"
          @click.prevent="$refs.upload.clear"
        > -->
        <button
          type="button"
          class="btn secondary-btn"
          @click.prevent="cancelUpload()"
        >
          Cancel
        </button>
        <button type="submit" class="btn primary-btn" @click.prevent="editSave">
          Save
        </button>
      </div>
    </div>
     <!-- Confirm POP UP START-->
        <ConfirmBox ref="confirmcomp" :showmodal="showCnfrmPopUp" :actionmessage="actionMsg" @cancelAction="showCnfrmPopUp = false; confrmPopUpResponse = false;" @confirmAction="showCnfrmPopUp = false; confrmPopUpResponse = true;">
            <!--
                you can use custom content here to overwrite
                default content
                <h3 slot="header">{{customheadertxt}}</h3>
            -->
        </ConfirmBox>
        <!-- Confirm POP UP END-->
    <transition name="fade">
      <Messages
        v-if="isdisplaymsg"
        v-bind:datamessage="sucessmsgtext"
        v-on:closemsg="closeMessage"
        v-bind:isVisible="this.isdisplaymsg"
      ></Messages>
    </transition>
    <div></div>
  </div>
</template>

<style>
.example-avatar .avatar-upload .rounded-circle {
  width: 100px;
  height: 100px;
}
.example-avatar .text-center .btn {
  margin: 0 0.5rem;
}
.example-avatar .avatar-edit-image {
  max-width: 100%;
}
.example-avatar .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.example-avatar .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}

.file-uploads.file-uploads-html5:before {
  width: 20px;
  height: 20px;
  content: "";
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 10px;
  background: url(../../static/images/dashboard-newicons.png) -113px -505px
    no-repeat;
}
.file-uploads {
  text-align: left !important;
}
.uploaded-image-box {
  position: relative;
}
.multi-image {
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  height: 30px;
  width: 36px;
  text-align: center;
  color: #ffffff;
  right: 15px;
  padding-top: 6px;
  bottom: 0px;
  cursor: pointer;
}
.multi-images-list.none{display:none;}
.multi-images-list.block{display:block;}
.multi-images-list {
  position: absolute;
  width: 240px;
  top: 110px;
  right: 15px;
  border-radius: 5px;
  background: #e8e9eb;
  z-index: 9;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.multi-images-list:after {
  content: "";
  display: block;
  position: absolute;
  right: 10px;
  bottom: 100%;
  width: 0;
  height: 0;
  border-bottom: 10px solid #e8e9eb;
  border-top: 10px solid transparent;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.multi-images-list .view-image {
  background: url(../../static/images/material_co_icon.png) -5px -377px
    no-repeat;
  text-indent: -50000em;
  width: 25px;
  height: 20px;
}
.multi-images-list .view-image:hover {
  background: url(../../static/images/material_co_icon.png) -66px -377px
    no-repeat;
  text-indent: -50000em;
  width: 25px;
  height: 20px;
}
.multi-images-list .delete-image {
  background: url(../../static/images/material_co_icon.png) -1px -505px
    no-repeat;
  text-indent: -50000em;
  width: 25px;
  height: 25px;
}
.multi-images-list .delete-image:hover {
  background: url(../../static/images/material_co_icon.png) -73px -505px
    no-repeat;
  text-indent: -50000em;
  width: 25px;
  height: 25px;
}

.multi-images-list .col-md-12 .row {
  padding: 5px 15px;
}
.multi-images-list .col-md-12:first-child .row {
  padding-top: 10px;
}
.multi-images-list .col-md-12:last-child .row {
  padding-bottom: 10px;
}
/*.multi-images-list .col-md-12 .row:hover { background: #f4f4f4;}*/

.multi-images-list .col-md-12 .row:hover .image-name a {
  color: #0157e0;
}

.image-name {
  line-height: 22px;
  color: #353b47;
}
.image-name a {
  color: #353b47;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  display: inline-block;
}
.file-uploads {
  text-align: left !important;
}
</style>

<script>
import rest_service from "@/api/rest_service";
import { mapActions, mapGetters, Store } from "vuex";
import Cropper from "cropperjs";
import FileUpload from "vue-upload-component";
import s3api from "@/api/s3api";
import StaffAPI from "@/api/staff";
import ImageUploadAPI from "@/api/ImageUpload";
import Messages from "@/components/MessagePopup/Messages";
import moment from "moment";
import Axios from "axios";
import InvoiceReceiptApi from '../../api/InvoiceReceipt.js'
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";

export default {
  props: ["parentproperty"],
  name:"singleimageuploadcomponent",
  components: {
    FileUpload,
    Messages,
    ConfirmBox
  },
  data() {
    return {
      showCnfrmPopUp:false,
      confrmPopUpResponse:false,
      actionMsg:"",
      customheadertxt:"Confirm Action",
      recordToDelete:"",
      encidtodelete:"",
      encounterimage:[],
      encounter_date:null,
      patEncno:null,
      uploadesImageUrl: "",
      getdownloadfileUrl: "",
      authenticationToken: "",
      loggeedin_userinfo: "",
      imgfilename: "",
      tenantId: "",
      role_unique_id: "",
      encounterData: {},
      isdisplaymsg: false,
      sucessmsgtext: "",
      staffpicfile: [],
      edit: false,
      cropper: false,
      uploaded_file_name: "",
      show_remove_logo_button: false,
      Isfiledelete: false,
      default_logo_url:
        "https://genamet-static-uploads-dev.s3.amazonaws.com/0/images/profile_photo/view-default-image.png", //this.$store.state.helper.st_default_staff_logo_url,
      loggedin_user_unique_id: "",
      staffdetails: {},
      profile_pic_url: "",
      profile_pic_name: "",
      loggedin_user_unique_id: "",
      UploadedImage: [],
      provider_id: "",
      encounterDataprops:{},
      parent:this,
      imagecount:0,
      patientDetails:{},
      showimglist:false,
      closelsdpdwn:0 // don't delete this, this is being used in  parent component
    };
  },
  watch: {
    edit(value) {
      if (value) {
        this.$nextTick(function() {
          if (!this.$refs.editImage) {
            return;
          }
          let cropper = new Cropper(this.$refs.editImage, {
            //aspectRatio: 1 / 1,
            viewMode: 1
          });
          this.cropper = cropper;
        });
      } else {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = false;
        }
      }
    }
  },
  methods: {
    ...mapActions(["ac_uploadToS3bucket"]),
    getimageuploadeddata(){
      var self= this;
      var param={
        encounter_id:this.$route.query.range_key,
        scanIndexForward:false
      }
 ImageUploadAPI.getimagelistbyencounterid(param).then(function(response) {
        if (response != null && response != undefined && response.result) {
          self.encounterimage = response.result;
          if(self.encounterimage&&self.encounterimage.length){
          var temp_image=[];
          self.encounterimage.forEach(element => {
             var data = {};
            data.Image_Name = element.report_user_friendly_name;
            data.Uploaded_date = moment(element.uploaded_date).format(
              "DD-MM-YYYY"
            );
            data.file_key = element.report_file_key;
            data.unique_id = element.unique_id;
            data.encounter_id = element.encounter_id;
            data.customer_id = element.customer_id;
            temp_image.push(data);
          });
            self.UploadedImage = temp_image;
            self.imagecount=0;
            self.imagecount = self.UploadedImage.length;
            if(self.encounterimage[0].last_uploaded_Img_key)
            {
              
              self.foldername =
                self.tenantId +
                self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
                self.encounterimage[0].last_uploaded_Img_key;
                self.$store.state.helper.st_filekeydata="";
            self.$store.state.helper.st_filekeydata = self.foldername;
            self.getS3imageurl(self.foldername);
            } 
          }                                           
          else{
            if(localStorage.getItem("lastuploadedimage")){   
              localStorage.removeItem("lastuploadedimage");            
              self.uploadesImageUrl = "";
            }              
          }               
          // return response;
        } else {
           self.encounterimage=[];
        }
      });
    },
    getencdata(){
        var self=this;
       var masterdata = {
                    range_key: this.$route.query.range_key
                };
                rest_service
                .get("/formrender/getformrenderbyid", this.tenantId, masterdata)
                .then(respo => {
                    if (respo.data && respo.data.result) {
                        this.encounterDataprops = respo.data.result;
                        if (this.encounterDataprops) {
                        console.log("CompParentProperty");
                        console.log(this.encounterDataprops.encounterData);
                        this.encounterData = this.encounterDataprops;
                        if (this.encounterData && this.encounterData.uploadedImageslist && this.encounterData.uploadedImageslist.length) {
                          var temp_image = [];
                          this.encounterData.uploadedImageslist.forEach(element => {
                            var data = {};
                            data.Image_Name = element.report_user_friendly_name;
                            data.Uploaded_date = moment(element.uploaded_date).format(
                              "DD-MM-YYYY"
                            );
                            data.file_key = element.report_file_key;
                            temp_image.push(data);
                          });
                          this.UploadedImage = temp_image;
                          this.imagecount=0;
                          this.imagecount = this.UploadedImage.length;
                          if(self.encounterData.last_uploaded_Img_key)
                          {
                            
                            self.foldername =
                              self.tenantId +
                              self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
                              self.encounterData.last_uploaded_Img_key;
                              self.$store.state.helper.st_filekeydata="";
                          self.$store.state.helper.st_filekeydata = self.foldername;
                          self.getS3imageurl(self.foldername);
                          }
                          
                        }
                        else{
                           self.$store.state.helper.st_filekeydata="";
                           self.uploadesImageUrl="";
                        }
                      }
                    }
                });
    },
    cancelUpload(){
      console.log("PARENT");
      console.log(this.parent.encounterDataprops.patient_encounter_number);
      this.parent.$refs.upload.clear();
      if(this.$store.state.helper.st_filekeydata){
        this.getS3imageurl(this.$store.state.helper.st_filekeydata);
      }
      
    },
    getstaffdetailsbyid(param) {
      //alert("Edit method called");
      var self = this;
      StaffAPI.getstaffbyid(param).then(categResponse => {
        if (categResponse.statusCode == 200) {
          if (localStorage.getItem("staffprofilepic"))
            window.localStorage.removeItem("staffprofilepic");
          localStorage.setItem(
            "staffprofilepic",
            JSON.stringify(categResponse.result)
          );
        }
      });
    },
    deleteImage(unique_id, encid) {
      this.showCnfrmPopUp = false;
      this.confrmPopUpResponse = false;
      if(unique_id && encid){
       this.recordToDelete = unique_id;
       this.encidtodelete = encid;
       this.showCnfrmPopUp = true;
       this.actionMsg = "Are you sure you want to delete?";
      }
    },
    confirmDelete(unique_id,encid){
      var self=this;
      if (this.encounterimage.length) {
        this.encounterimage.forEach(
          element => {
            if (element.unique_id == unique_id) {
              var params={
                unique_id:element.unique_id,
                customer_id:element.customer_id
              }
              ImageUploadAPI.removeImages(params)
              .then(categResponse => {
                if(categResponse)
                {
                  self.imagecount -=1;
                  self.isdisplaymsg = true;
                  self.sucessmsgtext = "Image deleted successfully";
                  self.getimageuploadeddata();
                }
            });
            }
            
          }
        );   
        
  
    
    }
    },
      
    listImages() {
      this.showimglist=this.showimglist?false:true;
    },
    viewFile(itemKey, report_Type) {
      this.getdownloadfileUrl = null;
      if (typeof itemKey === "string" && itemKey && report_Type === "file") {
        this.foldername =
          this.tenantId +
          this.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
          itemKey;
      }

      this.viewItem = true;
      this.downLoadItem = false;

      this.getUrlFromS3Bucket(this.foldername);
    },
    getUrlFromS3Bucket(fileKey) {
      var self = this;
      var suburl = "/S3Proxy";
      var apiUrl = rest_service.baseURL + suburl + "/getfileurl";
      return Axios.get(apiUrl, {
        headers: {
          x_tenant_id: this.tenantId,
          role_unique_id: this.role_unique_id,
          route_entity_name: suburl,
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken,
          report_key: fileKey
        }
      })
        .then(function(response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            //console.log("REPORT VIEW URL>>>>>",self.getdownloadfileUrl);
            window.open(self.getdownloadfileUrl, "_blank", "channelmode=1");
          } else {
            return null;
          }
        })
        .catch(function(error) {
          return error;
        });
    },
       getS3imageurl(fileKey) {
      var self = this;
      var suburl = "/S3Proxy";
      var apiUrl = rest_service.baseURL + suburl + "/getfileurl";
      return Axios.get(apiUrl, {
        headers: {
          x_tenant_id: this.tenantId,
          role_unique_id: this.role_unique_id,
          route_entity_name: suburl,
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken,
          report_key: fileKey
        }
      })
        .then(function(response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            if(localStorage.getItem("lastuploadedimage")){
              localStorage.removeItem("lastuploadedimage");
              localStorage.setItem("lastuploadedimage",self.getdownloadfileUrl);
              self.uploadesImageUrl = localStorage.getItem("lastuploadedimage");
            }
            else{
              localStorage.setItem("lastuploadedimage",self.getdownloadfileUrl);
              self.uploadesImageUrl = localStorage.getItem("lastuploadedimage");
            }
            //console.log("REPORT VIEW URL>>>>>",self.getdownloadfileUrl);
            //window.open(self.getdownloadfileUrl, "_blank", "channelmode=1");
          } else {
            return null;
          }
        })
        .catch(function(error) {
          return error;
        });
    },
    closeMessage() {
      this.isdisplaymsg = false;
    },
    editSave() {
      var self = this;
      this.edit = false;
      let oldFile = this.staffpicfile[0];
      console.log(oldFile);
      let binStr = atob(
        this.cropper
          .getCroppedCanvas()
          .toDataURL(oldFile.type)
          .split(",")[1]
      );
      let arr = new Uint8Array(binStr.length);
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      let file = new File([arr], oldFile.name, { type: oldFile.type });
      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true
      });
      var fileData = new FormData();
      fileData.append("file", file);
      fileData.append(
        "subfoldername",
        this.$store.state.helper.st_upload_pic_to_ehr
      );

      //this.$store.state.staff.st_profilepic_filedata = file;
      //   var extension = file.name.split(".").pop();
      var extension = file.name;
      this.imgfilename = file.name;
      if (this.$route.params.uniqueid && this.tenantId) {
        var filenamewithextension =
          this.tenantId +
          "_" +
          this.$route.params.uniqueid +
          "." +
          extension.toLowerCase();
      } else {
        var filenamewithextension =
          //   this.tenantId+"_"+this.loggedin_user_unique_id + "." + extension.toLowerCase();
          this.tenantId + "_" + this.loggedin_user_unique_id + "_" + extension;
      }
      //var filenamewithextension = this.loggedin_user_unique_id + "." + extension.toLowerCase();
      fileData.append("filenamewithextension", filenamewithextension);
      var fileinformation = {
        file: file,
        filename: filenamewithextension,
        foldername: "/reports-images/"
      };
      //upload to s3
      //this.ac_uploadToS3bucket(fileinformation);
        s3api
        .uploadImagetoS3(
          this.$store.state.helper.tenant_id,
          fileinformation.file,
          fileinformation.filename,
          fileinformation.foldername
        )
        .then(respo => {
          if (respo.status == 200) {
            self.isdisplaymsg = true;
            self.sucessmsgtext = "Image uploaded successfully";
            //alert("File Uploades successfully")
            //if (self.encounterData.uploadedImageslist) {
              var encdata = {};
              var imgData={};
              if(sessionStorage.getItem("encounterdetails")){
                var encounData= JSON.parse(sessionStorage.getItem("encounterdetails"))
                this.patEncno = encounData.patient_encounter_number;
                this.encounter_date = encounData.created_date;
              }
              encdata.created_userid = this.loggedin_user_unique_id;
              encdata.created_username =
                this.loggeedin_userinfo.first_name +
                " " +
                this.loggeedin_userinfo.last_name;
              encdata.report_actual_name = this.imgfilename;
              encdata.report_file_key = respo.data.message;
              encdata.report_user_friendly_name = this.imgfilename;
              //encdata.uploaded_date = new Date().toISOString();
              encdata.patient_encounter_number = this.patEncno;
              encdata.customer_id = this.$route.query.patient_id;
              if(this.$route.query.encounter_id){
                 encdata.encounter_id = this.$route.query.encounter_id;
              }
              else{
                encdata.encounter_id = this.$route.query.range_key;
              }
              encdata.visit_date = this.encounter_date;
              //imgData.last_uploaded_Img_key =respo.data.message;
               encdata.last_uploaded_Img_key =respo.data.message;
              // self.encounterData.uploadedImageslist.push(encdata);
              // self.encounterData.last_uploaded_Img_key = imgData.last_uploaded_Img_key;
              self.imagecount+=1;
               if (typeof encdata.report_file_key === "string" && encdata.report_file_key) {
                self.foldername =
                  self.tenantId +
                  self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
                  encdata.report_file_key;
              }
              self.getS3imageurl(self.foldername);
               ImageUploadAPI.imageUpload(encdata).then(categResponse => {
                  if (categResponse.statusCode == 201) {
                   self.isdisplaymsg = true;
                   self.sucessmsgtext = "Clinical notes updated successfully";
                   self.getimageuploadeddata();
                  }
                });
              // rest_service
              //   .put("/formrender", self.encounterData, this.tenantId)
              //   .then(respo => {
              //     this.isspinner = false;
              //     this.isdisplaymsg = true;
              //     this.sucessmsgtext = "Clinical notes updated successfully";
              //     this.getencdata();
              //   });
              //   if(this.patientDetails){
              // var encdata = {};
              // encdata.created_userid = this.loggedin_user_unique_id;
              // encdata.created_username =
              //   this.loggeedin_userinfo.first_name +
              //   " " +
              //   this.loggeedin_userinfo.last_name;
              // encdata.report_actual_name = this.imgfilename;
              // encdata.report_file_key = respo.data.message;
              // encdata.report_user_friendly_name = this.imgfilename;
              // encdata.uploaded_date = new Date().toISOString();
              // encdata.patient_encounter_number = this.patEncno;
              // if(this.$route.query.encounter_id){
              //    encdata.encounter_id = this.$route.query.encounter_id;
              // }
              // else{
              //   encdata.encounter_id = this.$route.query.range_key;
              // }
              // encdata.visit_date = this.encounter_date;
              // imgData.last_uploaded_Img_key =respo.data.message;
              // self.patientDetails.uploadedImageslist.push(encdata);
              //  rest_service.put("/customer", self.patientDetails, self.tenantId).then(respo => {
              //          self.isdisplaymsg = true;
              //           self.sucessmsgtext = "Customer updated successfully";
              //           self.getpatientDetails(this.$route.query.patient_id);
              //   });
              //   }
            //} 
            // else {
            //   var encdata = {};
            //   var imgData={};
            //   self.encounterData.uploadedImageslist = [];
            //   encdata.created_userid = this.loggedin_user_unique_id;
            //   encdata.created_username =
            //     this.loggeedin_userinfo.first_name +
            //     " " +
            //     this.loggeedin_userinfo.last_name;
            //   encdata.report_actual_name = this.imgfilename;
            //   encdata.report_file_key = respo.data.message;
            //   encdata.report_user_friendly_name = this.imgfilename;
            //   encdata.uploaded_date = new Date().toISOString();
            //   encdata.patient_encounter_number = this.patEncno;
            //   if(this.$route.query.encounter_id){
            //      encdata.encounter_id = this.$route.query.encounter_id;
            //   }
            //   else{
            //     encdata.encounter_id = this.$route.query.range_key;
            //   }
            //   encdata.visit_date = this.encounter_date;
            //   imgData.last_uploaded_Img_key =respo.data.message;
            //   self.encounterData.uploadedImageslist.push(encdata);
            //   self.imagecount+=1;
            //   self.encounterData.last_uploaded_Img_key = imgData.last_uploaded_Img_key;
            //   if (typeof encdata.report_file_key === "string" && encdata.report_file_key) {
            //     self.foldername =
            //       self.tenantId +
            //       self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
            //       encdata.report_file_key;
            //   }
            //   self.getS3imageurl(self.foldername);
            //   rest_service
            //     .put("/formrender", self.encounterData, this.tenantId)
            //     .then(respo => {
            //       this.isspinner = false;
            //       this.isdisplaymsg = true;
            //       this.sucessmsgtext = "Clinical notes updated successfully";
            //       this.getencdata();
            //     });
            //   if(this.patientDetails){
            //   var encdata = {};
            //   if(!self.patientDetails.uploadedImageslist){
            //     self.patientDetails.uploadedImageslist=[];
            //   }
            //   encdata.created_userid = this.loggedin_user_unique_id;
            //   encdata.created_username =
            //     this.loggeedin_userinfo.first_name +
            //     " " +
            //     this.loggeedin_userinfo.last_name;
            //   encdata.report_actual_name = this.imgfilename;
            //   encdata.report_file_key = respo.data.message;
            //   encdata.report_user_friendly_name = this.imgfilename;
            //   encdata.uploaded_date = new Date().toISOString();
            //   encdata.patient_encounter_number = this.patEncno;
            //   if(this.$route.query.encounter_id){
            //      encdata.encounter_id = this.$route.query.encounter_id;
            //   }
            //   else{
            //     encdata.encounter_id = this.$route.query.range_key;
            //   }
            //   encdata.visit_date = this.encounter_date;
            //   imgData.last_uploaded_Img_key =respo.data.message;
            //   self.patientDetails.uploadedImageslist.push(encdata);
            //    rest_service.put("/customer", self.patientDetails, self.tenantId).then(respo => {
            //            self.isdisplaymsg = true;
            //             self.sucessmsgtext = "Customer updated successfully";
            //             self.getpatientDetails(this.$route.query.patient_id);
      
            //     });
            //     }
            // }
          }
          // self.isdisplaymsg=true;
          // self.sucessmsgtext="File uploaded successfully";
          // self.uploadFlag = false;
        });
      //upload to s3
    },
    getpatientDetails(patientid){
              InvoiceReceiptApi.getehrPatient(patientid)
                .then(ehrpatient => {
                    if (ehrpatient.data) {
                        //self.ehrpatient = JSON.parse(ehrpatient.data.result);
                        if(sessionStorage.getItem("encpatientdetails")){
                          sessionStorage.removeItem("encpatientdetails")
                          sessionStorage.setItem("encpatientdetails",ehrpatient.data.result)
                        }
                        else{
                          sessionStorage.setItem("encpatientdetails",ehrpatient.data.result)
                        }
                    }
                })
    },
    alert(message) {
      alert(message);
    },
    getguid() {
      var d = new Date().getTime();
      if (
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
      ) {
        d += performance.now(); //use high-precision timer if available
      }
      var newGuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return newGuid;
    },
    inputFile(newFile, oldFile, prevent) {
      //alert('inputFile method');
      if (newFile && !oldFile) {
        this.$nextTick(function() {
          this.edit = true;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      //alert('inputFilter method');
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
           this.isdisplaymsg = true;
           this.sucessmsgtext = "Selected item is not an image";
          //this.alert("Selected item is not an image");
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    RemoveStaffprofilepicture() {
      this.$store.state.helper.st_showconfirmalertpopup = true;
      this._props.parentproperty.confirmdeleteactionname = "deletelogo";
    }
  },

  updated() {
    setTimeout(
      function() {
        this.closeMessage();
      }.bind(this),
      3000
    );

    var iframe = $("#symtompnotetxtarea_ifr").contents();
    // iframe.find("body").click(function() {
    //   $(".multi-images-list").slideUp("slow");
    // });

    $(document).ready(function() {
      // $("mce-stack-layout-item").click(function() {
      //   $(".multi-images-list").slideToggle();
      // });

      // $(".multi-image").click(function(e) {
      //   $(".multi-images-list")
      //     .stop(true, true)
      //     .slideToggle("slow");
      //   e.stopPropagation();
      // });

      // $("body").click(function() {
      //   $(".multi-images-list:visible")
      //     .stop(true, true)
      //     .slideUp("slow");
      // });
    });
  },
  computed: {
    ...mapGetters(["gett_uploadedfile", "gett_deletededfile"]),
    getConfirmBoxResponse(){
      if(this.confrmPopUpResponse){
        this.confirmDelete(this.recordToDelete,this.encidtodelete);
      }
      else{
        this.confrmPopUpResponse = false;
      }
    },
    comp_Parent_Property() {
      var self=this;
       var masterdata = {
                    range_key: this.$route.query.range_key
                };
                rest_service
                .get("/formrender/getformrenderbyid", this.tenantId, masterdata)
                .then(respo => {
                    if (respo.data && respo.data.result) {
                        this.encounterDataprops = respo.data.result;
                        if (this.encounterDataprops) {
                        console.log("CompParentProperty");
                        console.log(this.encounterDataprops.encounterData);
                        this.encounterData = this.encounterDataprops;
                        if (this.encounterData && this.encounterData.uploadedImageslist && this.encounterData.uploadedImageslist.length) {
                          var temp_image = [];
                          this.encounterData.uploadedImageslist.forEach(element => {
                            var data = {};
                            data.Image_Name = element.report_user_friendly_name;
                            data.Uploaded_date = moment(element.uploaded_date).format(
                              "DD-MM-YYYY"
                            );
                            data.file_key = element.report_file_key;
                            temp_image.push(data);
                          });
                          this.UploadedImage = temp_image;
                          this.imagecount=0;
                          this.imagecount = this.UploadedImage.length;
                          if(self.encounterData.last_uploaded_Img_key)
                          {
                            
                            self.foldername =
                              self.tenantId +
                              self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
                              self.encounterData.last_uploaded_Img_key;
                              self.$store.state.helper.st_filekeydata="";
                          self.$store.state.helper.st_filekeydata = self.foldername;
                          self.getS3imageurl(self.foldername);
                          }
                         
                        }
                        else{
                          self.$store.state.helper.st_filekeydata="";
                          self.uploadesImageUrl="";
                          localStorage.removeItem("lastuploadedimage");
                        }
                      }
                    }
                });
     
    },
    com_gett_uploadedfile: function() {
      if (this.gett_uploadedfile) {
        alert("Computed method called");
        //alert('com_gett_uploadedfile computed prop');
        var self = this;
        //update to business setup
        this.uploaded_file_name = this.gett_uploadedfile;
        rest_service
          .updatestaffprofilepicfilename(
            this.uploaded_file_name,
            this.$route.params.uniqueid,
            this.$store.state.helper.tenant_id
          )
          .then(respo => {
            if (respo.status == 201) {
              var loggedUserInfo = JSON.parse(
                window.localStorage.getItem("loggedInUserInfo")
              );

              if (loggedUserInfo) {
                var currentdatetime = new Date();
                var currentdatetimemili = currentdatetime.getTime();
                var extension = self.uploaded_file_name.split(".");

                if (extension[0] == loggedUserInfo.unique_id) {
                  self.$parent.$parent.$data.mutedloggedinuserinfo.profile_pic_url =
                    self.$store.state.helper.st_s3bucket_name +
                    self.$store.state.helper.tenant_id +
                    "/" +
                    self.$store.state.helper.st_upload_pic_to_ehr +
                    "/" +
                    self.uploaded_file_name +
                    "?v=" +
                    currentdatetimemili;
                  loggedUserInfo.profile_pic_file_name =
                    self.uploaded_file_name;
                  window.localStorage.setItem(
                    "loggedInUserInfo",
                    JSON.stringify(loggedUserInfo)
                  );
                }
              }
            }
          });
        this.show_remove_logo_button = true;
      } else {
        if (this.staffpicfile.length > 0) {
          if (this.staffpicfile[0].url) {
            var extension = this.staffpicfile[0].name.split(".").pop();
            var filenamewithextension =
              this.$route.params.uniqueid + "." + extension;
            this.uploaded_file_name = filenamewithextension;
           if(localStorage.getItem("lastuploadedimage")){
            this.uploadesImageUrl = localStorage.getItem("lastuploadedimage");
          }
          else{
            this.uploadesImageUrl = "";
          }
          }
        } else if (
          this.UploadedImage.length == 0 &&
          this.staffpicfile.length == 0
        ) {
          this.uploadesImageUrl = "";
        } 
        else if(this.staffpicfile.length == 0&&this.UploadedImage.length>0){
          this.uploadesImageUrl = "";
        }
        else {
          this.uploadesImageUrl = localStorage.getItem("uploadedImage");
          //this.uploadesImageUrl = "";
        }
      }
      return this.gett_uploadedfile;
    },
    com_default_logo_url: function() {
      if (localStorage.getItem("staffprofilepic")) {
        var staffdata = JSON.parse(
          window.localStorage.getItem("staffprofilepic")
        );
        if (staffdata.unique_id == this.$route.params.uniqueid) {
          this.default_logo_url = staffdata.profile_pic_url;
          this.show_remove_logo_button = true;
          this.uploaded_file_name = staffdata.profile_pic_file_name;
        } else {
          this.default_logo_url =
            "https://genamet-static-uploads-dev.s3.amazonaws.com/0/images/profile_photo/view-default-image.png";
        }
      }
      // if (this._props.parentproperty.gett_staff) {
      //   //alert('com_default_logo_url computed prop');
      //   if (this.staffpicfile.length == 0 && this._props.parentproperty.gett_staff.profile_pic_file_name && this.Isfiledelete==false) {

      //     var currentdatetime = new Date();
      //     var currentdatetimemili = currentdatetime.getTime();
      //     var awsFolderName =this.$store.state.helper.tenant_id +"/" +
      //       this.$store.state.helper.st_staff_logo_folder +
      //       "/" +
      //       this._props.parentproperty.gett_staff.profile_pic_file_name +
      //       "?v=" +
      //       currentdatetimemili;

      //     this.default_logo_url =
      //       this.$store.state.helper.st_s3bucket_name + awsFolderName;
      //     this.show_remove_logo_button = true;
      //     this.uploaded_file_name = this._props.parentproperty.gett_staff.profile_pic_file_name;
      //   }
      // }
      else {
        this.default_logo_url =
          "https://genamet-static-uploads-dev.s3.amazonaws.com/0/images/profile_photo/view-default-image.png";
      }
      // if (this._props.parentproperty.gett_staff) {
      //   if (this.staffpicfile.length == 0 && this._props.parentproperty.gett_staff.profile_pic_url) {
      //     this.default_logo_url = this._props.parentproperty.gett_staff.profile_pic_url;
      //     this.show_remove_logo_button = true;
      //     this.uploaded_file_name = this._props.parentproperty.gett_staff.profile_pic_file_name;
      //   }
      // }
    },
    com_gett_deletededfile() {
      if (this.gett_deletededfile) {
        //alert('com_gett_deletededfile computed prop');
        this.Isfiledelete = true;
        this.show_remove_logo_button = false;
        this.staffpicfile = [];
        this.default_logo_url =
          "https://genamet-static-uploads-dev.s3.amazonaws.com/0/images/profile_photo/view-default-image.png";

        rest_service
          .updatestaffprofilepicfilename(
            "",
            this.$route.params.uniqueid,
            this.$store.state.helper.tenant_id
          )
          .then(respo => {});
        this.$store.state.S3Proxy.st_Isfiledeleted = false;
        this._props.parentproperty.gett_staff.profile_pic_file_name = "";
        var loggedUserInfo = JSON.parse(
          window.localStorage.getItem("loggedInUserInfo")
        );
        if (loggedUserInfo) {
          if (
            this._props.parentproperty.gett_staff.unique_id ==
            loggedUserInfo.unique_id
          ) {
            this.$parent.$parent.$data.mutedloggedinuserinfo.profile_pic_url = this.$store.state.helper.st_default_staff_logo_url;
          }
        }
      }

      return this.gett_deletededfile;
    }
  },
  created() {
    if (window.localStorage.getItem("loggedInUserInfo")) {
      this.loggeedin_userinfo = JSON.parse(
        window.localStorage.getItem("loggedInUserInfo")
      );
      this.loggedin_user_unique_id = this.loggeedin_userinfo.unique_id;
      this.role_unique_id = this.loggeedin_userinfo.role.unique_id;
    }
    console.log("Files data in created: " + this.staffpicfile);
    if (window.localStorage.getItem("accesstoken")) {
      this.authenticationToken = window.localStorage.getItem("accesstoken");
    }
    if (localStorage.getItem("tenantid")) {
      this.tenantId = localStorage.getItem("tenantid");
    }
    
    console.log("Parentproperty");
    console.log(this.parentproperty.encounterData);
    if( sessionStorage.getItem("encpatientdetails")){
      this.patientDetails =  JSON.parse(sessionStorage.getItem("encpatientdetails"));
    }
      
    //this.getencdata();
    this.getimageuploadeddata();
    // var masterdata = {
    //   range_key: this.$route.query.range_key
    // };

    // /**
    //  * WHY IS THIS REPEATING CALL NECESSARY???????
    //  */
    // rest_service
    //   .get("/formrender/getformrenderbyid", this.tenantId, masterdata)
    //   .then(respo => {
    //     if (respo.data && respo.data.result) {
    //       this.encounterData = respo.data.result;

    //       //this.encounterData.created_date = moment(this.encounterData.created_date).format("DD-MM-YYYY");
    //     }
    //   })
    //   .finally(() => {});
  },
  mounted() {
    //console.log("Files data in mounted: " + this.staffpicfile);
     this.getencdata();
  }
};
</script>

<style>
label.btn.btn-primary.file-uploads.file-uploads-html5.file-uploads-drop {
  color: white;
  padding: 6px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.btn-center {
  margin-left: auto;
  margin-right: auto;
  float: none !important;
}

.cropper-bg,
.cropper-crop {
  height: 200px !important;
  width: 100% !important;
}
.cropper-crop-box {
  transform: translateX(25.1px) translateY(15.7px) !important;
  max-height: 90% !important;
  max-width: 80% !important;
}
</style>
